import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const navItems = [
  { name: '首页', path: '/' },
  { name: '分类浏览', path: '/category/all' },
  { name: '材质对比', path: '/category/cailiao' },
  { name: '款式推荐', path: '/category/kuanshi' },
  { name: '品牌推荐', path: '/category/pinpai' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2 group">
            <span className="font-heading text-xl md:text-2xl font-bold text-primary-500 tracking-wide">
              内裤精选指南
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === item.path
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-600 hover:text-primary-500 hover:bg-primary-50/50'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          isMobileOpen ? 'max-h-96 border-t border-background-200/60 bg-background-50/95 backdrop-blur-md' : 'max-h-0'
        }`}
      >
        <div className="px-4 py-3 space-y-1">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`block px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-200 ${
                location.pathname === item.path
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-600 hover:text-primary-500 hover:bg-primary-50/50'
              }`}
            >
              {item.name}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}